import React, { useEffect, useState } from "react";
import "./about.scss";

const images = [
  process.env.PUBLIC_URL + '/images/pizzachef.png',
  process.env.PUBLIC_URL + '/images/pizzahongo.jpg',
  process.env.PUBLIC_URL + '/images/pizzaorno.jpg',
  process.env.PUBLIC_URL + '/images/pizzasvarias.jpg',
  process.env.PUBLIC_URL + '/images/pizzhorno.jpg'
];

function AboutCarousel() {
  const [current, setCurrent] = useState(0);
  useEffect(() => {
    const interval = setInterval(() => {
      setCurrent((prev) => (prev + 1) % images.length);
    }, 3000);
    return () => clearInterval(interval);
  }, []);
  return (
    <img
      src={images[current]}
      alt={`slide-${current}`}
      style={{width: '100%', height: '100%', objectFit: 'cover', borderRadius: '2rem'}}
    />
  );
}

const About = () => {
  return (
    <section id="about" className="about">
      <div className="container">
        <div className="row">
          <div className="aboutContainer">
            <div className="aboutContainerImg bgImg">
              <AboutCarousel />
            </div>
            <div className="aboutContainerDetails">
              <h1>
                <span className="colorGrey">We</span> create delicious memories
                for<span className="colorGrey"> us</span>
              </h1>
              <p>
                We cook the best food in the entire city, with excellent
                customer service, the best meals and at the best price, visit
                us.
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default About;
